import { captureException, withErrorBoundary } from '@sentry/react'
import { createFileRoute } from '@tanstack/react-router'

import { SentryErrorPage } from '@/pages/error/SentryErrorPage'
import { PromotionShopPage } from '@/pages/promotions/PromotionShopPage'
import { promotionsConfigurationQuery } from '@/state/configuration/promotionsConfiguration'

export const Route = createFileRoute('/promotions/$initiativeId/$regionId/boutique')({
  component: withErrorBoundary(PromotionShopPage, {
    fallback: SentryErrorPage,
    beforeCapture: (scope) => scope.setTag('route', Route.fullPath),
  }),
  loader: async ({ context }) => {
    await context.queryClient.prefetchQuery(promotionsConfigurationQuery())
  },
  onCatch: (error) => {
    captureException(error, { tags: { route: Route.fullPath } })
  },
})
